import {memo} from 'react';

import {Placeholder} from '../components/placeholder.js';
import {
  SelectedItem,
  SelectedItems as SelectedItemsComponent,
} from '../components/selected_items.js';
import {useMultiComboBoxContext} from '../context.js';

type SelectedItemsProps = {
  placeholder?: string;
  className?: string;
  expandSelectedItems?: boolean;
};

const SelectedItems = memo(function SelectedItems<T>({
  placeholder = 'Select values',
  className,
  expandSelectedItems = false,
}: SelectedItemsProps) {
  const {
    clearable,
    selectedItems,
    removeSelectedItem,
    itemToString,
    itemToKey,
    getSelectedItemProps,
  } = useMultiComboBoxContext<T>();

  return (
    <SelectedItemsComponent className={className} expand={expandSelectedItems}>
      {selectedItems.length === 0 && <Placeholder text={placeholder} />}
      {selectedItems.map((item, index) => (
        <SelectedItem
          {...getSelectedItemProps({selectedItem: item, index})}
          key={`${itemToKey(item)}-${index}-selected`}
          text={itemToString(item)}
          title={expandSelectedItems ? itemToString(item) : undefined}
          onRemove={
            clearable
              ? () => {
                  removeSelectedItem(item);
                }
              : undefined
          }
        />
      ))}
    </SelectedItemsComponent>
  );
});

export type {SelectedItemsProps};
export {SelectedItems};
